import BooksService from '@/hexapla-core/domains/resources/books'
import { Book, Meta } from '@/hexapla-core/domains/resources'

export interface UseBooksService {
  listBooks: () => Promise<Book[]>
  bookMeta: (src: string, id: string | number) => Promise<Meta>
  showBook: (id: string | number) => Promise<Book>
  createBook: (book: Book) => Promise<Book>
  updateBook: (book: Book) => Promise<Book>
  deleteBook: (id: string | number) => Promise<void>
}

export function useBooksService(url: string): UseBooksService {
  return {
    listBooks: () => BooksService.index(url),
    bookMeta: (src: string, id: string | number) => BooksService.meta(url, src, id),
    createBook: (book: Book) => BooksService.create(url, book),
    showBook: (id: string | number) => BooksService.show(url, id),
    updateBook: (book: Book) => BooksService.update(url, book),
    deleteBook: (id: string | number) => BooksService.destroy(url, id),
  }
}
